import { c as _c } from "react/compiler-runtime";
import { createUuid } from '@core/utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

// [임시] 네이버 API EOS 대응: 위치 조회 비활성화 (복구 시 원복)
// import ky from 'ky';
// import { AuthApi, UnauthApi } from '@/api';
import type { GEOLOCATION_VIEW_TYPE } from '@/constants/geo';
import { DEFAULT_LOCATION } from '@/constants/geo';
import { useAuthStore } from '@/stores/AuthStore';
import { useLocationConsent } from './useLocationConsent';
const LOCATION_QUERY_KEY = createUuid();

// [임시] 네이버 API EOS 대응으로 위치 조회 비활성화 (복구 시 원복)
// type ReverseGeocodingContext = NonNullable<
//   Awaited<
//     ReturnType<
//       (typeof UnauthApi)['get:/wello/v2/allows/wello-policy-code/reverse-geocoding']
//     >
//   >['data']
// >['context'];

interface UseLocationOptions {
  /** 초기 데이터 가져오기 활성화 여부 */
  enabledInitialFetch?: boolean;
  geolocationViewType?: GEOLOCATION_VIEW_TYPE;
}
export const useLocation = t0 => {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabledInitialFetch: t2,
    geolocationViewType
  } = t1;
  const enabledInitialFetch = t2 === undefined ? false : t2;
  const isLogin = useAuthStore(_temp);
  const {
    isConsented,
    ensureConsent
  } = useLocationConsent();
  let t3;
  if ($[2] !== geolocationViewType || $[3] !== isConsented || $[4] !== isLogin) {
    t3 = [LOCATION_QUERY_KEY, isLogin, isConsented, geolocationViewType];
    $[2] = geolocationViewType;
    $[3] = isConsented;
    $[4] = isLogin;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== ensureConsent) {
    t4 = async () => {
      const agreed = await ensureConsent();
      if (!agreed) {
        return DEFAULT_LOCATION;
      }
      return DEFAULT_LOCATION;
    };
    $[6] = ensureConsent;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isConsented !== undefined && enabledInitialFetch;
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey: t3,
      placeholderData: keepPreviousData,
      staleTime: 0,
      gcTime: 0,
      queryFn: t4,
      enabled: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return useQuery(t6);
};
export type LocationData = Exclude<Awaited<ReturnType<typeof useLocation>>['data'], undefined>;
function _temp(state) {
  return state.isLogin;
}